export const avatarStore = {
  base64: '',
  clubBase64: ''
};

export interface IAvatarStore {
  base64: string;
  clubBase64: string;
}
